import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { hasMinimumLength, removeEmpty, truncateText } from '@/utils/resultsHelper';
import { isSplitUrl, joinUrl } from '@/constants/urls';

const listItem = (item, index, activeIndex, textField, errors, intl) => {
  const className = errors.includes(index.toString()) ? 'error' : '';
  const checkUrl = isSplitUrl(item[textField]) ? joinUrl(item[textField]) : item[textField];
  const text = hasMinimumLength(checkUrl) ? truncateText(checkUrl, 60) : intl.formatMessage({ id: 'not.specified' });

  return {
    key: `form_object_dropdown_item_${index}`,
    text,
    value: index,
    active: index === activeIndex,
    className,
  };
};

const listItems = (items, activeIndex, textField, errors, intl) => removeEmpty(items.map(
  (item, index) => (item ? listItem(item, index, activeIndex, textField, errors, intl) : null),
));

const FormObjectDropdown = ({
  activeIndex,
  className,
  disabled,
  errors = [],
  inline,
  items,
  message,
  onChange,
  searchable,
  textField,
}) => {
  const intl = useIntl();
  return (
    <Dropdown
      className={clsx('aridhia-form-object-dropdown', className)}
      disabled={disabled}
      inline={inline}
      onChange={(e, { value }) => onChange({ index: value })}
      options={listItems(items, activeIndex, textField, errors, intl)}
      placeholder={message ? intl.formatMessage({ id: message }) : null}
      scrolling={inline}
      search={searchable}
      selection={!inline}
      value={activeIndex}
    />
  );
};

export default FormObjectDropdown;
